<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_v"></a>List of Maps</h2>
<p class="list"><span class="list_float">1</span> The West Indies Theatre</p>
<p class="list"><span class="list_float">2</span> Grey’s movements on Martinique, March 1794.</p>
<p class="list"><span class="list_float">3</span> The Capture of Saint Lucia, April 1794.</p>
<p class="list"><span class="list_float">4</span> The Capture of Guadeloupe, April 1794.</p>
<p class="list"><span class="list_float">5</span> The Loss of Guadeloupe, October-December 1794.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list_of_maps.vue?9a47ef44